import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { TRANSLATIONS } from "./translations";

const LanguageContext = createContext({ lang: "en", setLang: () => {}, t: (k) => k });

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    try {
      const saved = localStorage.getItem("smv_lang");
      return saved === "kn" || saved === "en" ? saved : "en";
    } catch {
      return "en";
    }
  });

  const setLang = useCallback((l) => {
    setLangState(l);
    try { localStorage.setItem("smv_lang", l); } catch { /* ignore quota errors */ }
  }, []);

  const t = useCallback(
    (key, fallback) => {
      const entry = TRANSLATIONS[key];
      if (!entry) return fallback ?? key;
      return entry[lang] ?? entry.en ?? fallback ?? key;
    },
    [lang]
  );

  useEffect(() => {
    document.documentElement.lang = lang === "kn" ? "kn" : "en";
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
